import React, { useCallback, useEffect, useState } from "react";
import EmployeeDetail from "./Components/employeeDetail";
import PayrollHeaderVerification from "./Components/payrollHeaderVerification";
import PayrollContentVerification from "./Components/payrollContentVerification";
import axios from "axios";
import moment from "moment";
import { getUserId, ShowError } from "../../_helper/helper";
import { useAuth } from "oidc-react";
import { toast } from "react-toastify";
import PrintIcon from "@mui/icons-material/Print";
import { IconButton } from "@mui/material";


const TimesheetMain = (props) => {
  const { ppeEndDate, isShow = true } = props;
  const { userData } = useAuth();

  const [price, setPrice] = useState(5);
  const [allPayPeriod, setAllPayPeriod] = React.useState([]);
  const [selectedPayPeriod, setSelectedPayPeriod] = React.useState({});
  const [empId, setEmpId] = useState(getUserId(userData));
  const [leaveShare, setLeaveShare] = useState([]);
  const [leaveHours, setLeaveHours] = useState({
    alLeaveHours: 0,
    slLeaveHours: 0,
  });
  const [leaveHoursTR, setLeaveHoursTR] = useState({
    TRalLeaveHours: 0,
    TRslLeaveHours: 0,
  });
  const [userObject, setUserObject] = useState();
  const [rowsData, setRowsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openModalPrint, setOpenModalPrint] = useState(false);

  const [leaveShareDisplay, setLeaveShareDisplay] = useState({
    ALleave: 0, // "00:00"
    SLleave: 0,
  });
  const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;

  const getPayPeriod = async () => {
    // vw_payperiod_master
    const payload = {
      tableName: "PayPeriodMaster",
      params: [],
      columns: "*",
      page: 1,
      pageSize: 10000000,
      orderBy: "ID",
      sortBy: "asc",
      orderByMultiple: "",
      limit: 10000000000,
      sortData: " ID asc",
      additionalWhere: "",
    };
    await axios
      .get(`${newBaseURL}/PayTimeCodes/payperiod`, {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("jwt_access_token")}`,
          Role: "user",
        },
      })
      .then((response) => {
        // let createObj = [];
        if (response.data.data.length) {
          const queryParams = new URLSearchParams(window.location.search);

          let resPaycode = response.data.data;
          resPaycode = resPaycode.map((i) => {
            return {
              StartDate: moment(i.startDate).format("YYYY-MM-DD"),
              EndDate: moment(i.endDate).format("YYYY-MM-DD"),
              ID: i.id,
              WeekBreakDate: moment(i.WeekBreakDate).format("YYYY-MM-DD"),
              lockTimeKeeper: i.lockTimeKeeper,
              lockSupervisor: i.lockSupervisor,
              lockOverall: i.lockOverall,
            };
          });
          let tody = moment().format("YYYY-MM-DD");
          let allpayperiod = resPaycode.filter((i) => {
            return i.StartDate <= tody;
          });

          setAllPayPeriod(allpayperiod);
          if (!queryParams.get("ppe")) {
            let currentPayPeriod = resPaycode.find((i) => {
              return i.StartDate <= tody && i.EndDate >= tody;
            });
            if (currentPayPeriod == undefined) {
              setSelectedPayPeriod(resPaycode[resPaycode.length - 1]);
            } else {
              if (ppeEndDate) {
                let selectedPPE = allpayperiod?.find(
                  (item) =>
                    item.EndDate ==
                    moment(ppeEndDate, "MM-DD-YYYY").format("YYYY-MM-DD")
                );
                setSelectedPayPeriod(selectedPPE);
              } else {
                setSelectedPayPeriod(currentPayPeriod);
              }
            }
          } else {
          }
        }
      })
      .catch((error) => {
        console.warn("Cannot retrieve user data", error);
      });
  };

  useEffect(() => {
    getPayPeriod();
  }, []);
  const getUserInfo = useCallback(() => {
    //Employee Data

    if (!empId) {
      return false;
    } else {
      axios
        .get(
          `${newBaseURL}/Employee/GetEmployeePRMasterDetails`,
          {
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ${sessionStorage.getItem("jwt_access_token")}`,
              Role: "user",
            },
          }
        )
        .then((response) => {
          // Split the string into an array using the comma as a delimiter

          let userInfo = response.data.data.employeePayrollMaster;
          let employeeStatuses = response.data.data.employeeStatuses;
          let departmentDivisionMaster =
            response.data.data.departmentDivisionMaster;
          let employeeInfo = response.data.data.employeeInfo;
          let empInfo = employeeInfo?.length
            ? employeeInfo.find(
              (item) =>
                item.employee_id_Sequence == userInfo?.employeeIdSequence
            )
            : null;
          if (!empInfo && employeeInfo?.length) {
            empInfo = employeeInfo[0];
          }
          const JobOrders = userInfo?.recent_joborders;
          const JobOrdersArray = JobOrders ? JobOrders.split(",") : [];
          let newObj = {
            DPDV: userInfo.dpdv,
            EmployeeName: userInfo.employeeName,
            DPDV_DepartmentDivisionMaster: departmentDivisionMaster,
            EmployeeStatuses: employeeStatuses,
            ID: userInfo.employeeID || userInfo.employeeNo,
            Seq: userInfo.seq,
            Status: userInfo.status,
            Rate: userInfo.hourlyRate ? userInfo.hourlyRate : 0,
            EmployeementDate: userInfo?.date_Employment,
            employeeInfo: employeeInfo.length ? employeeInfo[0] : [],
            tag_Name: userInfo?.tagCode,
            tag_Code: userInfo?.tagCode,
            exemptFlag: userInfo?.exemptFlag,
            ALleaveBalancemin: empInfo?.annual_Leave_Balance
              ? (
                (empInfo?.annual_Leave_Balance -
                  userInfo?.reservedAnnualLeaveBalance) *
                60
              )?.toFixed(2)
              : 0,
            SLleaveBalancemin: empInfo?.sick_Leave_Balance
              ? (
                (empInfo?.sick_Leave_Balance -
                  userInfo.reservedSickLeaveBalance) *
                60
              )?.toFixed(2)
              : 0,
            ALleaveBalanceHR: empInfo?.annual_Leave_Balance
              ? empInfo?.annual_Leave_Balance -
              userInfo?.reservedAnnualLeaveBalance
              : 0,
            SLleaveBalanceHR: empInfo?.sick_Leave_Balance
              ? empInfo?.sick_Leave_Balance - userInfo.reservedSickLeaveBalance
              : 0,

            // TRALleaveBalancemin: userInfo?.transferredAlReceived ? ((userInfo?.transferredAlReceived) * 60)?.toFixed(2) : 0 ,
            // TRSLleaveBalancemin : userInfo?.transferredSlReceived ? ((userInfo?.transferredSlReceived) * 60)?.toFixed(2) : 0,
            // TRALleaveBalanceHR:  userInfo?.transferredAlReceived ? (userInfo?.transferredAlReceived) : 0,
            // TRSLleaveBalanceHR :  userInfo?.transferredSlReceived ? (userInfo?.transferredSlReceived) : 0,

            TRALleaveBalancemin: userInfo?.transferredAlBalance
              ? (userInfo?.transferredAlBalance * 60)?.toFixed(2)
              : 0,
            TRSLleaveBalancemin: userInfo?.transferredSlBalance
              ? (userInfo?.transferredSlBalance * 60)?.toFixed(2)
              : 0,
            TRALleaveBalanceHR: userInfo?.transferredAlBalance
              ? userInfo?.transferredAlBalance
              : 0,
            TRSLleaveBalanceHR: userInfo?.transferredSlBalance
              ? userInfo?.transferredSlBalance
              : 0,

            empJobOrder: JobOrdersArray,
            empJobOrderNumber: userInfo?.jobOrderNumber,
            employeeIdSequence: userInfo?.employeeIdSequence,
            GNG_militaryLeave: userInfo?.fyGngMilitaryLeaveHours
              ? userInfo?.fyGngMilitaryLeaveHours -
              userInfo.reservedFyGngMilitaryLeaveHours
              : 0,
            GNG_militaryLeavemin: userInfo?.fyGngMilitaryLeaveHours
              ? (
                (userInfo?.fyGngMilitaryLeaveHours -
                  userInfo.reservedFyGngMilitaryLeaveHours) *
                60
              )?.toFixed(2)
              : 0,
            militaryLeaveAllow:
              userInfo?.guamNationalGuardFlag?.trim() == "Y" ||
                userInfo?.militaryBranch?.trim() !== "" ||
                !userInfo?.militaryBranch
                ? true
                : false,
          };

          setPrice(userInfo.rate ? userInfo.rate : 10.0);
          // setEmployeeProcessPayTimes(userInfo.EmployeeProcessPayTimes);
          let leaveShareData = response.data.data?.leaveshare;

          if (leaveShareData?.length) {
            leaveShareData = leaveShareData.map((i, index) => {
              let beginDate = moment(i.eff_Donated_Begin_Date).format(
                "YYYY-MM-DD"
              );
              let endDate = moment(i.eff_Donated_End_Date).format("YYYY-MM-DD");
              return {
                ...i,
                donor_Hrly_Rate: parseFloat(i.donor_Hrly_Rate).toFixed(2),
                // id: KeyGen(7),
                orderNo: index,
                id: i.pR_Donated_Leave_Request_Id,
                obligated_Donated_Sl_Min:
                  (i.obligated_Donated_Sl
                    ? i.obligated_Donated_Sl
                    : i.donated_Sl_Bal) * 60,
                obligated_Donated_Al_Min:
                  (i.obligated_Donated_Al
                    ? i.obligated_Donated_Al
                    : i.donated_Al_Bal) * 60,
                obligated_Donated_Sl:
                  (i.obligated_Donated_Sl
                    ? i.obligated_Donated_Sl
                    : i.donated_Sl_Bal) * 60,
                obligated_Donated_Al:
                  (i.obligated_Donated_Al
                    ? i.obligated_Donated_Al
                    : i.donated_Al_Bal) * 60,
                donated_Sl_Used_Min: i.donated_Sl_Used * 60,
                donated_Al_Used_Min: i.donated_Al_Used * 60,
                reserved_donated_sl: i.reserved_donated_sl * 60,
                reserved_donated_al: i.reserved_donated_al * 60,
                begin_Date: beginDate,
                end_Date: endDate,
                displayAvailableBalanceSL:
                  (i.obligated_Donated_Sl
                    ? i.obligated_Donated_Sl
                    : i.donated_Sl_Bal) *
                  60 -
                  i.reserved_donated_sl * 60,
                displayAvailableBalanceAL:
                  (i.obligated_Donated_Al
                    ? i.obligated_Donated_Al
                    : i.donated_Al_Bal) *
                  60 -
                  i.reserved_donated_al * 60,
              };
            });
            leaveShareData.sort((a, b) => a.orderno - b.orderno);
          }
          setLeaveShare(leaveShareData);

          // setEmployeeStatuses(userInfo.EmployeeStatuses);

          setLeaveHours({
            alLeaveHours: newObj?.ALleaveBalanceHR,
            slLeaveHours: newObj.SLleaveBalanceHR,
          });
          setLeaveHoursTR({
            TRalLeaveHours: newObj?.TRALleaveBalanceHR,
            TRslLeaveHours: newObj.TRSLleaveBalanceHR,
          });
          setUserObject(newObj);
        })
        .catch((error) => {
          setIsLoading(false);
          ShowError("Employee Not Found", {
            position: toast.POSITION.TOP_RIGHT,
          });
          console.warn("Cannot retrieve user data", error);
        });
    }
  }, [empId]);

  useEffect(() => {
    if (ppeEndDate && allPayPeriod?.length) {
      let selectedPPE = allPayPeriod?.find(
        (item) =>
          item.EndDate == moment(ppeEndDate, "MM-DD-YYYY").format("YYYY-MM-DD")
      );
      setSelectedPayPeriod(selectedPPE);
    }
  }, [ppeEndDate, allPayPeriod]);

  useEffect(() => {
    if (empId) {
      getUserInfo();
    }
  }, [empId]);

  return (
    <div>
      {isShow ? (
        <div>
          <PayrollHeaderVerification
            allPayPeriod={allPayPeriod}
            setPayPeriod={setSelectedPayPeriod}
            payPeriod={selectedPayPeriod}
            openModalPrint={openModalPrint}
            setOpenModalPrint={setOpenModalPrint}
          />
        </div>
      ) : (
        <div style={{ textAlign: "end" }}>
          <IconButton
            onClick={() => {
              setOpenModalPrint(!openModalPrint);
            }}
          >
            <PrintIcon />
          </IconButton>
        </div>
      )}
      <EmployeeDetail
        price={price}
        setPrice={setPrice}
        userInfo={userObject}
        // EmployeeStatuses,
        // isloading,

        // empCertifications,
        leaveShareDisplay={leaveShareDisplay}
        // getRulesValue,
        leaveHours={leaveHours}
        leaveHoursTR={leaveHoursTR}
      />
      <div>
        <PayrollContentVerification
          payPeriod={selectedPayPeriod}
          userId={empId}
          price={price}
          rowsData={rowsData}
          setIsLoading={setIsLoading}
          setRowsData={setRowsData}
          isLoading={isLoading}
          openModalPrint={openModalPrint}
          setOpenModalPrint={setOpenModalPrint}
          userObject={userObject}
        />
      </div>
    </div>
  );
};

export default TimesheetMain;
